import { cn } from "@/libs/utils";
import { IconBaseType } from "@/v2-components/core/icon/type";

export default function HeadDeviceIcon({ className }: IconBaseType) {
  return (
    <svg
      className={cn("w-4.5 h-4.5", className)}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1 12.825C11.4583 12.825 10.9374 12.3111 10.9374 11.6775C10.9374 11.0439 11.4583 10.53 12.1 10.53C12.9545 10.53 13.65 9.84357 13.65 9.00005C13.65 8.1563 12.9545 7.47005 12.1 7.47005H5.89985C5.04508 7.47005 4.35005 8.1563 4.35005 9.00005C4.35005 9.84357 5.04508 10.53 5.89985 10.53C6.54223 10.53 7.06243 11.0439 7.06243 11.6775C7.06243 12.3111 6.54223 12.825 5.89985 12.825C3.76348 12.825 2.0249 11.109 2.0249 9.00005C2.0249 6.89112 3.76348 5.17505 5.89985 5.17505H12.1C14.2366 5.17505 15.9749 6.89112 15.9749 9.00005C15.9749 11.109 14.2366 12.825 12.1 12.825Z"
        fill="currentColor"
      />
    </svg>
  );
}
